export function getEnabledDirections(settings) {
  const { positions, invertedPositions } = settings;

  return Object.entries({
    ...(positions || {}),
    ...(invertedPositions || {}),
  })
    .filter(([, enabled]) => enabled)
    .map(([key]) => key);
}

export function isAllDiagonalEnabled(enabledDirections) {
  const diagonalStrategies = ['diagonal', 'invertedDiagonal'];
  return diagonalStrategies.every(dir => enabledDirections.includes(dir));
}

function canFitInDirection(word, direction, rows, cols) {
  const len = word.length;

  const baseDirection = direction.replace(/^inverted/i, '').toLowerCase();

  if (baseDirection.includes('horizontal')) return len <= cols;
  if (baseDirection.includes('vertical')) return len <= rows;
  if (baseDirection.includes('diagonal')) return len <= rows && len <= cols;

  return false;
}

export function canFitAnyDirection(word, enabledDirections, rows, columns) {
  for (let i = 0; i < enabledDirections.length; i += 1) {
    const direction = enabledDirections[i];
    if (canFitInDirection(word, direction, rows, columns)) {
      return true;
    }
  }
  return false;
}

export function resolveValidDirection(word, initialDirection, enabledDirections, rows, cols) {
  if (canFitInDirection(word, initialDirection, rows, cols)) {
    return initialDirection;
  }

  const possibleDirections = enabledDirections.filter(direction =>
    canFitInDirection(word, direction, rows, cols),
  );

  if (possibleDirections.length === 0) return null;

  return possibleDirections[0];
}

